export default __webpack_public_path__ + "81819e7d06c1e06c6eb1c0593fc866d6.png";